import campaigns from 'Views/Campaigns/I18n/es';

const es = {
	home: {
		title: ' Portal empresas',
		dashboard: {
			title: 'Dashboard de salud',
			text: 'Consulta los datos generales de salud de los colaboradores',
		},
		employees: {
			title: 'Colaboradores',
			text: 'Consulta los datos generales de salud de los colaboradores',
		},
		candidates: {
			title: 'Candidatos',
			text: 'Gestión de exámenes de ingreso, compatibilidad del puesto',
		},
		nom035: {
			title: 'NOM-035',
			text: 'Mide los factores de riesgo y el entorno organizacional',
		},
		hra: {
			title: 'Health Risk Assessment',
			text: 'Monitorea los programas de salud de tus colaboradores.',
		},
		users: {
			title: 'Gestión de usuarios',
			text: 'Consulta los datos generales de salud de los colaboradores',
		},
		jobProfiles: {
			title: 'Perfiles de puesto',
			text: 'Conoce los factores de riesgo de tus colaboradores',
		},
	},
	commons: {
		cancel: 'Cancelar',
		retryButton: 'Intentar de nuevo',
		moreInfo: 'Más información',
		xlsx: {
			buttonText: 'Generar reporte',
			success:
				'¡Generando reporte! En cuanto esté listo lo enviaremos a tu correo electrónico',
			error: 'Hubo un error al generar el reporte ¿Deseas intentar de nuevo?',
		},
	},
	views: {
		campaigns,
	},
};

export default es;
